import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../constants';

import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import SvgComponent from '../SvgComponent';
import { LoadingComponent } from '../loading/LoadingComponent';

import './CarouselComponent.scss';

const SlickButton = ({ currentSlide, slideCount, children, ...props }) => (
    <span {...props}>{children}</span>
);

class CarouselComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { slide: 0 };
    }

    setFocusOnCurrentItem = e => {
        const { id } = this.props;

        setTimeout(() => {
            const focusableElements = '[tabindex]:not([tabindex="-1"]';
            const currentItem = document.querySelector(`#${id} .slick-current`);

            if (currentItem) {
                const firstFocusableElement = currentItem.querySelectorAll(focusableElements)[0];
                if (firstFocusableElement) {
                    firstFocusableElement.focus({ focusVisible: true });
                }
            }
        }, 100);
    };

    defaultOptions = ({ children, CARROUSEL_ARROW_LEFT, CARROUSEL_ARROW_RIGHT }) => ({
        prevArrow: (
            <SlickButton>
                <button
                    className="slick-prev slick-arrow flex-container-v flex-center fleche fleche-g"
                    tabIndex="0"
                    onClick={this.setFocusOnCurrentItem}>
                    <span className="sr-only">
                        {convertHtmlToReactDomWithParams(
                            CARROUSEL_ARROW_LEFT,
                            this.state.slide + 1,
                            children.length
                        )}
                    </span>
                    <SvgComponent
                        src={`${STATIC_ROOT}/fleche.svg`}
                        className="gauche"
                        width="12"
                        height="22"
                        aria-hidden="true"
                        focusable="false"
                    />
                </button>
            </SlickButton>
        ),
        nextArrow: (
            <SlickButton>
                <button
                    className="slick-next slick-arrow flex-container-v flex-center fleche fleche-d"
                    tabIndex="0"
                    onClick={this.setFocusOnCurrentItem}>
                    <span className="sr-only">
                        {convertHtmlToReactDomWithParams(
                            CARROUSEL_ARROW_RIGHT,
                            this.state.slide + 1,
                            children.length
                        )}
                    </span>
                    <SvgComponent
                        src={`${STATIC_ROOT}/fleche.svg`}
                        width="12"
                        height="22"
                        aria-hidden="true"
                        focusable="false"
                    />
                </button>
            </SlickButton>
        )
    });

    renderCarrousel = () => {
        const { children, CARROUSEL_ARROW_LEFT, CARROUSEL_ARROW_RIGHT } = this.props;

        if (children && children.length > 0) {
            return (
                <Slider
                    {...{
                        afterChange: current => this.setState({ slide: current }),
                        ...this.defaultOptions({
                            children,
                            CARROUSEL_ARROW_LEFT,
                            CARROUSEL_ARROW_RIGHT
                        }),
                        ...this.props.options
                    }}>
                    {children}
                </Slider>
            );
        } else {
            return (
                <div className="flex-container-v flex-center" id="loading">
                    <LoadingComponent />
                </div>
            );
        }
    };

    render() {
        return (
            <div className="carousel" id={this.props.id}>
                {this.renderCarrousel()}
            </div>
        );
    }
}

CarouselComponent.propTypes = {
    children: PropTypes.node,
    options: PropTypes.object
};

const mapStateToProps = state => ({
    CARROUSEL_ARROW_LEFT: state.i18n.feature.form.CARROUSEL_ARROW_LEFT,
    CARROUSEL_ARROW_RIGHT: state.i18n.feature.form.CARROUSEL_ARROW_RIGHT
});

export default connect(mapStateToProps)(CarouselComponent);



// WEBPACK FOOTER //
// ./src/components/carousel/CarouselComponent.js